class AnimalAttackType{

    constructor(){

        this.animalAttackType = [
            { id: 0, name: "犬" }, { id: 1, name: "貓" }, { id: 2, name: "其他外來種" }
            , { id: 3, name: "原生種攻擊" }, { id: 4, name: "送驗中/未知" }
        ]

    }

    getAnimalAttackType(){
        return this.animalAttackType;
    }

}

export default AnimalAttackType;